import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Divider,
  Paper,
  Typography,
  Container,
  withStyles,
  Box,
  Card,
  CardContent,
  FormControl,
  InputAdornment,
  SvgIcon,
} from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import { PatientActions } from "../../redux/actions/PatientActions";
import { DocumentActions } from "../../redux/actions/DocumentAction";
import DynamicFormViewInput from '../dynamicform/DynamicFormViewInput'
import { history } from "../helpers/History";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { USER_ROLE } from "../security/UserRole";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
  },
  table: {
    marginTop: theme.spacing(2),
    // display: "flex",
    // flexDirection: "column",
    alignItems: "center",
    // transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
    minHeight:250
  },avatar: {
    margin: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class DocumentList extends React.Component {
  constructor(props) {
    super(props);
    const documentid = this.props.match.params.documentid? this.props.match.params.documentid: "";
    this.state = {
      documentid : documentid,
      patientId: (this.props.userRole === USER_ROLE.PATIENT) ? this.props.patientId  : "",
      isCancelled :false,
    };
  }

  componentDidMount() {
    if (this.state.documentid) {
      this.props.getDocByIdRequest(this.state.documentid);
    }
  }
  componentWillUnmount() {
    this.props.clearAll();
  }


  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Patient</title>
        </Helmet>

        <Container component="main" fixed className={classes.main}>
          <CssBaseline />
            {
            this.props.documentDetails && this.props.documentDetails.id && 
              <DynamicFormViewInput 
              documentInfo =  {this.props.documentDetails}
              />
            }

            
              
                
            
          
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const documentDetails = state.document.documentDetails;
  const docSubmittedSuccessfully = state.document.docSubmittedSuccessfully;
  return { documentDetails ,docSubmittedSuccessfully};
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDocByIdRequest: (id) => dispatch(DocumentActions.getDocByIdRequest(id)),
    submitDocRequest: (payload) => dispatch(DocumentActions.submitDocRequest(payload)),
    clearAll : ()=> dispatch(DocumentActions.clearAll()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DocumentList));
